<mat-toolbar color="accent">
  Select Terminal &amp; Provider
  <span class="flex-1"></span>
  <button
    class="sync-button"
    mat-stroked-button
    [disabled]="syncInProgress()"
    (click)="sync()"
  >
    <mat-icon [class.animate-spin]="syncInProgress()">sync</mat-icon>
    {{ syncInProgress() ? 'Syncing' : 'Sync' }}
  </button>
</mat-toolbar>

@if (syncInProgress()) {
  <mat-progress-bar mode="buffer" [value]="syncPercentage()" />
}

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    @if (terminalGroups().length) {
      <mat-radio-group
        class="flex flex-col"
        [value]="selectedPairId()"
        [disabled]="syncInProgress()"
        (change)="entrySelected($event.value)"
      >
        @for (group of terminalGroups(); track group.terminalId) {
          <div
            class="flex items-center justify-between border-b border-gray-200 bg-gray-100 px-4 py-2"
          >
            <span class="text-sm font-medium">{{ group.terminalName }}</span>
            <span class="font-mono text-xs text-gray-500">{{
              group.terminalId
            }}</span>
          </div>

          @for (entry of group.entries; track entry.entryId) {
            <mat-radio-button
              class="border-b border-gray-100 px-4 py-1"
              [value]="entry.entryId"
              [disabled]="!entry.route"
            >
              <div class="flex items-center justify-between gap-4">
                <span>{{ entry.merchantDisplayName }}</span>
                @if (!entry.route) {
                  <span class="text-xs italic text-gray-400">
                    Inactive — no online bridge
                  </span>
                }
              </div>
            </mat-radio-button>
          }
        }
      </mat-radio-group>

      @if (selectedEntry(); as entry) {
        @if (selectedRoute(); as route) {
          <div
            class="flex flex-col gap-1 border-t border-gray-200 bg-gray-50 px-4 py-3"
          >
            <mat-form-field
              class="route-select"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <mat-label>Serving Bridge</mat-label>
              <mat-select
                [value]="effectiveCandidate()?.bridgeDevice?.ref?.id"
                [disabled]="syncInProgress()"
                (selectionChange)="bridgeChanged($event.value)"
              >
                @if (effectiveCandidate(); as candidate) {
                  <mat-select-trigger>
                    <div class="flex items-center gap-2 pr-6">
                      <ng-container
                        *ngTemplateOutlet="
                          bridgeRow;
                          context: {
                            candidate: candidate,
                            autoTooltip:
                              'Chosen automatically for this terminal'
                          }
                        "
                      ></ng-container>
                    </div>
                  </mat-select-trigger>
                }

                @for (
                  candidate of route.candidates;
                  track candidate.bridgeDevice.ref.id
                ) {
                  <mat-option
                    class="bridge-option"
                    [value]="candidate.bridgeDevice.ref.id"
                  >
                    <div class="flex w-full items-center gap-2">
                      <ng-container
                        *ngTemplateOutlet="
                          bridgeRow;
                          context: { candidate: candidate, autoTooltip: '' }
                        "
                      ></ng-container>
                    </div>
                  </mat-option>
                }
              </mat-select>
              <mat-hint class="text-xs text-gray-500">
                The bridge serving this payment. Chosen automatically — only
                change it if the terminal doesn't respond.
              </mat-hint>
            </mat-form-field>

            @if (showFallbackWarning()) {
              <div class="flex items-center gap-1 text-xs text-amber-700">
                <mat-icon class="icon-xs">warning</mat-icon>
                Preferred offline, using
                {{ effectiveCandidate()?.bridgeDevice.name }}
              </div>
            }
          </div>
        }
      }
    } @else {
      <div class="m-4">
        <p>No terminals found</p>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Close</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!selectedEntry() || !effectiveCandidate() || syncInProgress()"
      (click)="confirmSelection()"
    >
      Send to Terminal
    </button>
  </pt-buttons-container>
</mat-dialog-actions>

<ng-template #bridgeRow let-candidate="candidate" let-autoTooltip="autoTooltip">
  <span>{{ candidate.bridgeDevice.name }}</span>
  @if (candidate | map: isAutomaticCandidate) {
    <span
      class="rounded bg-gray-100 px-2 py-0.5 text-xs font-bold text-gray-600"
      [matTooltip]="autoTooltip"
    >
      Auto
    </span>
  }
  <span class="grow"></span>
  <pr-bridge-device-status dense [status]="candidate.bridgeDevice.status" />
</ng-template>
